<script setup lang="ts">
import Container from "../Container.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Container },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    text?: string;
    bgImageUrl?: string;
  }>(),
  {
    text: "文字背景为图片",
    bgImageUrl:
      "https://s3-us-west-2.amazonaws.com/s.cdpn.io/181794/kl-deer.png"
  }
);

// const emits = defineEmits<{
//   (event: "click"): void;
// }>();

defineExpose({});
</script>

<template>
  <Container>
    <div
      :style="{
        // backgroundImage: linear-gradient(45deg, lightblue, lightgreen);
        backgroundImage: `url(${props.bgImageUrl})`,
        'background-clip': 'text',
        // 文字设为透明
        color: 'transparent'
      }"
    >
      {{ props.text }}
    </div>
  </Container>
</template>
